import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import TrialExpired from "../trialExpired/TrialExpired";

interface TrialGuardProps {
  children: React.ReactNode;
}

const TrialGuard: React.FC<TrialGuardProps> = ({ children }) => {
  const [showTrialExpired, setShowTrialExpired] = useState<boolean>(false);
  const [isChecking, setIsChecking] = useState<boolean>(true);
  const location = useLocation();

  useEffect(() => {
    const checkTrialStatus = () => {
      const accessToken = localStorage.getItem("accessToken");
      const trialStatus = localStorage.getItem("trialStatus");
      const trialDaysRemaining = localStorage.getItem("trialDaysRemaining");
      if (!accessToken) {
        setIsChecking(false);
        return;
      }

      const FORCE_TRIAL_EXPIRED = false;

      const isTrialExpired =
        FORCE_TRIAL_EXPIRED ||
        (trialStatus === "false" &&
          trialDaysRemaining &&
          parseInt(trialDaysRemaining) === 0);
      //(0 <= 0); // for testing

      if (isTrialExpired) {
        setShowTrialExpired(true);
        setIsChecking(false);
      } else {
        setIsChecking(false);
      }
    };

    checkTrialStatus();
  }, []);

  if (isChecking) {
    return null;
  }

  if (showTrialExpired) {
    return (
      <>
        {children}
        <TrialExpired
          open={true}
          onClose={() => {
            /* Empty function - modal cannot be closed */
          }}
        />
      </>
    );
  }

  return <>{children}</>;
};

export default TrialGuard;
